import React, { useState } from 'react';
import logo from '../assets/img/logo.png';

const Navbar = ({ scrollToSection }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-sals-dark/95 backdrop-blur-sm shadow-lg fixed w-full z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => scrollToSection('home')}
          >
            <img 
              src={logo} 
              alt="SalsTech Logo" 
              className="h-10 md:h-12 w-auto object-contain"
            />
            <div className="ml-3">
              {/* <h1 className="text-xl md:text-2xl font-bold">
                <span className="text-sals-light">Sals</span>
                <span className="text-white">Tech</span>
              </h1> */}
              <p className="text-white/70 text-xs hidden sm:block">IT Solutions</p>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {['Home', 'Services', 'Products', 'About', 'Contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="text-white/90 hover:text-sals-light transition-all duration-300 font-medium relative group"
              >
                {item}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-sals-light transition-all duration-300 group-hover:w-full"></span>
              </button>
            ))}
            <button className="bg-sals-primary text-white px-5 py-2 rounded-lg font-semibold hover:bg-sals-light transition-all duration-300 transform hover:scale-105 shadow-lg">
              Get Quote
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-white focus:outline-none p-2 rounded-lg hover:bg-white/10 transition-colors"
              aria-label="Toggle menu"
            >
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-sals-dark/95 backdrop-blur-sm border-t border-sals-primary/30 animate-slideDown">
          <div className="px-4 pt-4 pb-6 space-y-3">
            {['Home', 'Services', 'Products', 'About', 'Contact'].map((item) => (
              <button
                key={item}
                onClick={() => {
                  scrollToSection(item.toLowerCase());
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-3 text-white/90 hover:text-sals-light hover:bg-white/5 rounded-lg transition-all duration-300"
              >
                {item}
              </button>
            ))}
            <button className="w-full bg-sals-primary text-white px-4 py-3 rounded-lg font-semibold hover:bg-sals-light transition-all duration-300">
              Get Quote
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;